import { render, staticRenderFns } from "./AttendanceAuditTrail.vue?vue&type=template&id=351dd9f0&scoped=true"
import script from "./AttendanceAuditTrail.vue?vue&type=script&lang=js"
export * from "./AttendanceAuditTrail.vue?vue&type=script&lang=js"
import style0 from "./AttendanceAuditTrail.vue?vue&type=style&index=0&id=351dd9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351dd9f0",
  null
  
)

export default component.exports